// extracted by mini-css-extract-plugin
export var nav = "navigation-module--nav--uUStU";
export var navItemLink = "navigation-module--navItemLink--tV-DL";
export var navItemLinkCurrent = "navigation-module--navItemLinkCurrent--dCWr4 navigation-module--navItemLink--tV-DL";
export var navItems = "navigation-module--navItems--bAid0";